<div class="alert-content" mat-dialog-content>
    <div class="red-alert-title" i18n="Onboarding|Cancel track">Cancel track?</div>
    <p i18n="Onboarding|Cancel track information">If you cancel track all of your existing information will be deleted?</p>
</div>
<mat-dialog-actions class="red-alert-actions">
    <button mat-button class="mat-primary" tabindex="-1" (click)="cancel()" i18n="Onboarding|Cancel track btn - no">No</button>
    <button mat-button class="mat-primary" tabindex="-1" (click)="confirm()" i18n="Onboarding|Cancel track btn - yes">Yes</button>
</mat-dialog-actions>
